// extracted by mini-css-extract-plugin
module.exports = {"container":"_81d9b20"};